import { api } from '@/utils/api';

/** Assign the selected contacts to a sequence (from the search selection bar). */
export const useSequenceAssignMutation = () => {
  const utils = api.useUtils();
  return api.sequence.assign.useMutation({
    onSuccess: () => {
      void utils.sequence.list.invalidate();
      // Assigning enrolls people → the per-node face counts on the sequence graph change.
      void utils.sequence.faces.invalidate();
    },
  });
};
